import { CircularIconButton } from './CircularIconButton';

type BooleanTagProps = {
  value: boolean;
  tooltip?: string;
};

export const BooleanTag = ({ value, tooltip }: BooleanTagProps) => (
  <CircularIconButton
    iconName={value ? 'check' : 'cancel'}
    intent={value ? 'success' : 'danger'}
    size="medium"
    tooltip={tooltip || (value ? 'Enabled' : 'Disabled')}
  />
);
